<template>
    <a-modal
            :width="width"
            :visible="visible"
            :closable="false"
            switchFullscreen
            :footer="null">
        <div>
            <p style="color:#000;text-align: center;font-weight: bold;">授权书</p>
            <p style="margin-top: 10px;margin-bottom: 10px;font-size: 15px;font-weight: bold;">
                我们（北京欣浩丰科技有限公司）非常重视用户信息的保护。我们希望通过本授权书向您说明手机号/地理位置填充服务中我们如何收集、使用、保护您的信息，以进一步保障您的信息安全和为您提供更便捷的服务。请您务必仔细阅读本授权书。您一旦主动在相应页面进行授权，即意味着您同意我们按照本授权书收集、使用您的姓名、手机号和地理位置信息。</p>
            <p>一、个人信息的收集</p>
            <p style="margin-top: 10px;margin-bottom: 10px;font-size: 15px;font-weight: bold;">
                1、您在使用登录手机号填充功能时，我们会收集您的手机号；您在使用历史手机号预填充功能时，我们会收集您的姓名、手机号。</p>
            <p style="margin-top: 10px;margin-bottom: 10px;font-size: 15px;font-weight: bold;">
                2、您在使用地理位置填充功能时，我们会收集您的地理位置信息。</p>
            <p>3、您需要注意的是，以上个人信息均是您自愿提供。如您不愿意提供，可以不授权或取消授权相关功能，我们将不再收集与该功能相关的个人信息。</p>
            <p>二、个人信息的使用</p>
            <p>1、您同意，我们可以通过以下方式对个人信息进行使用：</p>
            <p style="margin-top: 10px;margin-bottom: 10px;font-size: 15px;font-weight: bold;">
                A、登录手机号填充：在您授权我们使用您的登录手机号后，我们帮您把您的登录手机号填写到表单中。</p>
            <p style="margin-top: 10px;margin-bottom: 10px;font-size: 15px;font-weight: bold;">
                B、历史手机号预填充：当您同意使用该功能后，在您下次浏览橙子建站页面时，我们会帮您预先填写您上次输入的历史信息。</p>
            <p style="margin-top: 10px;margin-bottom: 10px;font-size: 15px;font-weight: bold;">
                C、地理位置填充：当您同意使用该功能后，我们会申请您的地理位置信息，用于填写本页面表单中的地理位置信息，或匹配表单中的相关地理位置信息供您选择。</p>
            <p>D、您可以手动修改这些预填充的信息。在您点击按钮提交之前，这些信息不会对外传输。</p>
            <p>
                E、我们致力于为您提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。为了维护我们服务的正常运行，保护您或其他用户或公众的合法利益免受损失，我们会收集用于维护产品或服务安全稳定运行的必要信息（例如您使用本服务的相关日志信息）。</p>
            <p>F、我们为满足您的需求，可能通过您提供的信息与您联系。</p>
            <p>G、我们可能定期或不定期向您发送有关产品、服务或相关活动的信息，但请你放心，如你不愿接收这些信息，你可以通过信息中的退订方式进行退订，也可以直接与我们联系进行退订。</p>
            <p>2、我们将严格保护您的个人信息安全。我们将采用适当制度、安全技术和程序等措施来保护您的个人信息不被未经授权的访问、使用或泄露。</p>
            <p style="margin-top: 10px;margin-bottom: 10px;font-size: 15px;font-weight: bold;">
                3、如您拟撤回授权/删除您提交的个人信息的，您可以取消授权历史手机号预填充/地理位置填充功能，我们将不再继续预填充并删除您的个人信息。
            </p>
            <p>三、未成年人信息的特殊保护</p>
            <p>1、若您是未满18周岁的未成年人，在使用本功能前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。</p>
            <p>2、若您是未满14周岁的未成年人的监护人，在使用本功能前，应为您的被监护人阅读并同意本隐私政策。</p>
            <p>四、适用法律 </p>
            <p>1、本声明适用中华人民共和国法律。</p>
            <p>五、变更</p>
            <p>我们会适时对本声明进行修订，该等修订构成本声明的一部分。我们会将修改后的声明予以发布。在该种情况下，若您继续使用我们的服务，即表示同意接受经修订的声明的约束。</p>
        </div>
        <template class="footer">
            <a-button block @click="handleCancel" style="width: 100%;color: #999;">我已阅读</a-button>
        </template>
    </a-modal>
</template>

<script>
    export default {
        name: "UserAuthorizeModal",
        data() {
            return {
                title: '授权书',
                width: 800,
                visible: false,
                disableSubmit: false,
            }
        },
        methods: {
            handleCancel() {
                this.visible = false
            }
        }
    }
</script>
<style lang="less" scoped>
</style>
